<template>
  <div class="center_skeleton">
    <v-progress-linear
      class="bar_data"
      indeterminate
      color="#00b0ff"
    ></v-progress-linear>
    <v-row>
      <v-col cols="12" md="6">
        <v-skeleton-loader class="" type="image"></v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="6">
        <v-skeleton-loader
          class="table_box_skeleton"
          type="table"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "SkeletonTableComp"
};
</script>

<style lang="scss">
.center_skeleton {
  width: 100%;
  padding: 20px;
  .bar_data {
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
}
</style>
